<template>
  <div class="validation_request_representative" v-if="validation_requestable">
    <div>
        <h5>{{validation_requestable.decoded_type}} {{ status(validation_requestable) }}</h5>
        <p>Qualité : {{validation_requestable.decoded_representative_quality}}</p>
        <p v-if="validation_requestable.moral_person">Personne morale : {{validation_requestable.corporation_name}}</p>
        <p>Nom : {{validation_requestable.decoded_civility}} {{validation_requestable.first_name}} {{validation_requestable.last_name}}</p>
        <p v-if="validation_requestable.mobile_phone">Tél. Mobile: {{validation_requestable.mobile_phone}}</p>
        <p v-if="validation_requestable.phone">Tél. Fixe: {{validation_requestable.phone}}</p>
        <p v-if="validation_requestable.email">
          Email: <a :href="'mailto:' + validation_requestable.email">{{validation_requestable.email}}</a>
        </p>
    </div>
    <div v-if="validation_requestable.representative_end_date" class="termination-date">
      Date de démission : {{validation_requestable.representative_end_date | moment-date}}
    </div>
  </div>
</template>

<script>
export default {
  name:"VrRepresentative",
  props:["validation_requestable"],
  methods: {
    status(vr) {
      if (vr.representative_main)
      {
        if ( vr.current )
          return "(principal actuel)"

        return "(principal)"
      }

      return "(secondaire)"
    },
  }
}
</script>

<style scoped>
.validation_request_representative {
    padding: 0 15px;
    border: solid 1px lightgray;
    background-color: white;
}

.validation_request_representative h5 { border-bottom: 1px solid lightgray; padding-bottom: 5px; }

.validation_request_representative .termination-date { font-weight: bold; margin-bottom: 10px; }
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/Representative.vue